import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import styled from "styled-components";
import { glow } from "theme";

import { useGoToActionCenter } from "NavBar/stateHooks";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import { marketingColors } from "UI/colors";

import {
  useIsHovered,
  useIsFocusVisible,
} from "Utilities/Hooks/useIsHoverFocused";
import dynBackgroundColor from "Utilities/interpolations/dynBackgroundColor";
import dynBorderRadius from "Utilities/interpolations/dynBorderRadius";

import ButtonSizer from "./ButtonSizer";
import { hoverTextKeys, useHoverTextKey } from "./accountAndSettingsStore";

const DashboardButton = () => {
  const goToActionCenter = useGoToActionCenter();
  const { pathname } = useLocation();
  const isActive =
    pathname.startsWith("/action-center") || pathname.startsWith("/dashboard");
  const buttonRef = useRef(null);
  const [, setHoverTextKey] = useHoverTextKey();
  const isHovered = useIsHovered(buttonRef);
  const isFocusVisible = useIsFocusVisible(buttonRef);

  useEffect(() => {
    if (isHovered || isFocusVisible) setHoverTextKey(hoverTextKeys.dashboard);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHovered, isFocusVisible, setHoverTextKey]);

  return (
    <FnrShineButton
      ref={buttonRef}
      aria-label="go-to-action-center"
      data-cy="NavBar_DashboardButton"
      onClick={goToActionCenter}
    >
      <ContentWrapper
        data-cy="NavBar_DashboardButton_Content"
        data-active={isActive}
        $backgroundColor={isActive ? "#ffffff" : undefined}
        $glowColor={marketingColors.blue}
        $noGlow={!isActive}
        $borderRadius="50%"
      >
        <ButtonSizer>
          <FnrContainedIcon
            noPadding
            color={isActive ? "brandFnBlue" : "textLight"}
            icon="ballot-check fas"
          />
        </ButtonSizer>
      </ContentWrapper>
    </FnrShineButton>
  );
};

const ContentWrapper = styled.div`
  ${dynBackgroundColor}
  ${glow}
  ${dynBorderRadius}
  position: relative;
  display: flex;
  align-items: center;
  transition: background-color 300ms ease-in-out, box-shadow 300ms ease-in-out;
`;

export default DashboardButton;
